import { render, staticRenderFns } from "./ExportAccountingDataButton.vue?vue&type=template&id=47ccdb45&"
import script from "./ExportAccountingDataButton.vue?vue&type=script&lang=js&"
export * from "./ExportAccountingDataButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports